import type { Category } from '../types/foundObject';

const DEFAULT_PROVIDER_SECRET_CLUES_PLACEHOLDER =
  'Information visible uniquement par votre équipe, jamais sur les annonces publiques.';

export function getSecretCluesPlaceholder(
  category?: Pick<Category, 'secret_clues_placeholder'> | null
): string {
  const custom = category?.secret_clues_placeholder?.trim();
  return custom || DEFAULT_PROVIDER_SECRET_CLUES_PLACEHOLDER;
}
